import { useState, useEffect } from 'react'
import apiClient from '../services/apiClient'
import StatusBadge from './StatusBadge'

/**
 * ExperimentViewModal — Read-only view of an AI Brief.
 *
 * Props:
 *   experiment  object  — must have .id
 *   onClose     fn()
 */
export default function ExperimentViewModal({ experiment, onClose }) {
  const [detail, setDetail] = useState(null)
  const [error, setError]   = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
    apiClient
      .get(`/admin/experiments/${experiment.id}`)
      .then((res) => setDetail(res.data))
      .catch(() => setError('Failed to load AI Brief details.'))
      .finally(() => setLoading(false))
  }, [experiment.id])

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" aria-labelledby="view-modal-title" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title" id="view-modal-title">AI Brief Details</h2>
          <button type="button" className="modal-close" onClick={onClose} aria-label="Close">
            ✕
          </button>
        </div>

        {loading && <p style={{ color: 'var(--text-secondary)' }}>Loading…</p>}

        {error && <div className="alert alert-danger">{error}</div>}

        {!loading && detail && (
          <>
            <div className="view-brief-header">
              <p className="view-brief-name">{detail.experiment_name}</p>
              <StatusBadge isActive={detail.is_active} />
            </div>

            <div>
              {detail.team_name && (
                <ViewField label="Team">{detail.team_name}</ViewField>
              )}
              {detail.project_info && (
                <ViewField label="Project Info">{detail.project_info}</ViewField>
              )}
              {detail.problem_statement && (
                <ViewField label="Problem Statement">{detail.problem_statement}</ViewField>
              )}
              {detail.hypothesis && (
                <ViewField label="Hypothesis">{detail.hypothesis}</ViewField>
              )}
              {detail.ai_approach && (
                <ViewField label="AI Approach">{detail.ai_approach}</ViewField>
              )}
              {detail.success_criteria && (
                <ViewField label="Success Criteria">{detail.success_criteria}</ViewField>
              )}
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onClose}>
                Close
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

function ViewField({ label, children }) {
  return (
    <div className="view-field">
      <p className="view-field-label">{label}</p>
      <p className="view-field-value">{children}</p>
    </div>
  )
}
